import gql from 'graphql-tag';
export const CREATE_CHECKOUT_SESSION = gql`
    mutation createCheckoutSession{
        createCheckoutSession
    }
`;